/* eslint-disable import/prefer-default-export */
import React from 'react';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { buildFormField } from '../../../components/Form/formFieldFactory';
import { isAnObject } from '../../../components/Form/validations';
import SearchBarSingle from '../../../components/SearchBarV3/SearchBarSingle';
import { PRIMARY_FONT } from '../../../theme/fontConstants';

const CorporationAgencySection = () => {
  const theme = useTheme();

  const sectionHeaderStyle = {
    color: theme?.palette?.text?.primary,
    fontSize: '20px',
    fontFamily: PRIMARY_FONT[700],
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(3),
  };

  const questionStyle = {
    color: theme?.palette?.text?.primary,
    fontSize: '16px',
    fontFamily: PRIMARY_FONT[300],
    marginBottom: theme.spacing(1),
  };

  const corporationField = () => ({
    ComponentType: SearchBarSingle,
    preDefinedOptions: [],
    data: {
      // FIXME: Make it paginated or fetch all at once or find another solution
      filters: [],
      limit: 100,
      page: 0,
    },
    key: 'id',
    name: 'corporation',
    testId: 'corporation',
    required: true,
    variant: 'standard',
    optionLabel: 'name',
    placeholder: 'Corporation',
    fullWidth: true,
    onSubmitApiCallData: {
      httpMethod: 'POST',
      route: 'corporations/read',
    },
    optionDisplayField: 'name',
    validate: isAnObject(),
  });

  const agencyField = () => ({
    ComponentType: SearchBarSingle,
    preDefinedOptions: [],
    data: {
      // FIXME: Make it paginated or fetch all at once or find another solution
      filters: [],
      limit: 100,
      page: 0,
    },
    key: 'id',
    name: 'agency',
    testId: 'agency',
    required: true,
    variant: 'standard',
    optionLabel: 'name',
    placeholder: 'Staffing Agency',
    fullWidth: true,
    onSubmitApiCallData: {
      httpMethod: 'POST',
      route: 'agency/read',
    },
    optionDisplayField: 'name',
    validate: isAnObject(),
  });

  return (
    <>
      <Typography sx={sectionHeaderStyle}>
        {LanguageConverterV2('contract.create.corporationInformation')}
      </Typography>

      <Typography sx={questionStyle}>
        {LanguageConverterV2('contract.create.corporationQuestion')}
      </Typography>
      <Box sx={{ mb: 3 }}>{buildFormField(corporationField())}</Box>

      <Typography sx={questionStyle}>
        {LanguageConverterV2('contract.create.agencyQuestion')}
      </Typography>
      <Box sx={{ mb: 3 }}>{buildFormField(agencyField())}</Box>
    </>
  );
};

export default CorporationAgencySection;
